// @ts-nocheck
import React, { useState } from "react";
import SharedSelect from "../components/SharedSelect";
import InfoPageLayout, { InfoSection } from "../components/InfoPageLayout";
import { submitFeedback } from "../api/feedback";
import { getUser } from "../auth/auth";
import { useToast } from "../components/ToastProvider";
import "../styles/InfoPage.css";

export default function ReportAbuse() {
  const { showToast } = useToast();
  const [details, setDetails] = useState("");
  const [reason, setReason] = useState("Spam or scam");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    if (!details.trim()) {
      showToast("Please include some details so our team can investigate.", "warning");
      return;
    }

    setSubmitting(true);

    try {
      const user = getUser();
      await submitFeedback({
        userId: user?.id,
        userName: user?.name || user?.username || "Authenticated user",
        userEmail: user?.email,
        category: "abuse_report",
        subject: reason,
        message: details.trim(),
        url: window.location.href,
        userAgent: navigator.userAgent,
      });
      setSubmitted(true);
      setDetails("");
      showToast("Report submitted. Our moderation team will review it.", "success");
    } catch (error) {
      showToast(error?.message || "Failed to submit report", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <InfoPageLayout
      title="Report Abuse"
      subtitle="Help us keep Cardex safe. Reports are reviewed promptly."
      updated="February 7, 2026"
    >
      <InfoSection title="What happened?">
        <p>Select a reason and add details if needed.</p>
        <div className="info-form">
          <div>
            <label className="info-label" htmlFor="report-reason">Reason</label>
            <SharedSelect
              id="report-reason"
              className="info-select"
              value={reason}
              onChange={(event) => setReason(event.target.value)}
            >
              <option>Spam or scam</option>
              <option>Harassment</option>
              <option>Suspicious behavior</option>
              <option>Fake or counterfeit cards</option>
              <option>Other</option>
            </SharedSelect>
          </div>

          <div>
            <label className="info-label" htmlFor="report-details">Details (optional)</label>
            <textarea
              id="report-details"
              className="info-textarea"
              value={details}
              onChange={(event) => setDetails(event.target.value)}
              placeholder="Share any relevant context."
              rows={4}
            />
            <p className="info-helper">For urgent safety issues, contact local authorities.</p>
          </div>

          <div className="info-actions">
            <button className="info-btn info-btn-secondary" onClick={() => setDetails("")}>
              Clear
            </button>
            <button className="info-btn info-btn-primary" onClick={handleSubmit} disabled={submitting}>
              {submitting ? "Submitting..." : submitted ? "Submitted" : "Submit Report"}
            </button>
          </div>
          {submitted && <p className="info-helper">Thanks. We logged your report for the moderation team.</p>}
        </div>
      </InfoSection>

      <InfoSection>
        <p style={{ textAlign: "center", color: "rgba(255, 255, 255, 0.7)", fontSize: "14px" }}>
          Reports are private and never shared with the reported user.
        </p>
      </InfoSection>
    </InfoPageLayout>
  );
}
